<div
  [class]="[
    'bankkonto-select-option-wrapper',
    isSelected ? 'highlighted' : ''
  ]"
  id="{{ id }}"
  (click)="doSelectOption()"
>
  <div class="content">
    <p class="bankbezeichnung">{{ bank }}</p>
    <p class="iban">IBAN: {{ label }}</p>
  </div>

  <jf-icon
    name="arrowRight"
    [size]="24"
    [strokeWidth]="1"
  ></jf-icon>
</div>
